import { render, staticRenderFns } from "./VacationsApproved.vue?vue&type=template&id=1d1a1fe3&scoped=true"
import script from "./VacationsApproved.vue?vue&type=script&lang=js"
export * from "./VacationsApproved.vue?vue&type=script&lang=js"
import style0 from "./VacationsApproved.vue?vue&type=style&index=0&id=1d1a1fe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a1fe3",
  null
  
)

export default component.exports